import Table from "../../Components/Table";
import { Link } from "react-router-dom";
import useTableControls from "../../Hooks/useTableControls";
import useFetchData from "../../Hooks/useFetchData";
import { getAdminLogs, resendCampaignNotification, deleteCampaignNotification } from "../../Services/Notification";
import { format_date, getSerialNumber } from "../../Utils/helpers";
import PageHeader from "../../Components/PageHeader";
import { Confirmation, Success, Error } from "../../Components/Modal";
import { useMutation } from "react-query";
import "../CMSManagement/CMSManagement.css";
import "./NotificationTemplates.css";

export default function NotificationManagement() {
    const {
        perPage,
        setPerPage,
        search_string,
        setSearchString,
        from,
        setFrom,
        to,
        setTo,
    } = useTableControls();

    const {
    page,
        setPage,
        isFetching,
        isLoading,
        data,
        refetch,
    } = useFetchData("notification_admin_logs", getAdminLogs, [
        perPage,
        from,
        to,
    ]);

    const { mutate: mutateResend, isLoading: resendLoading } = useMutation(
        (id) => resendCampaignNotification(id),
        {
            onSuccess: (res) => {
                Success("Campaign Resent", res.data?.message || "Notifications have been successfully broadcasted again.");
                refetch();
            },
            onError: (err) => {
                Error(err?.response?.data?.message || "Failed to resend campaign.");
            },
        }
    );

    const { mutate: mutateDelete, isLoading: deleteLoading } = useMutation(
        (id) => deleteCampaignNotification(id),
        {
            onSuccess: (res) => {
                Success("Campaign Deleted", res.data?.message || "The campaign log has been deleted successfully.");
                refetch();
            },
            onError: (err) => {
                Error(err?.response?.data?.message || "Failed to delete campaign.");
            },
        }
    );

    const handleResend = (id, title) => {
        Confirmation(
            `Are you sure you want to resend the campaign "${title}"? This will broadcast the push notification to the target segment again immediately.`,
            "Yes, Resend",
            () => {
                mutateResend(id);
            }
        );
    };

    const handleDelete = (id, title) => {
        Confirmation(
            `Are you sure you want to delete the campaign "${title}" from the logs? This action cannot be undone.`,
            "Yes, Delete",
            () => {
                mutateDelete(id);
            }
        );
    };

    return (
        <div className="app-content content">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="notification-logs">
                        <div className="row">
                            <div className="col-12">
                                <div className="user-details-wrapper">
                                    <PageHeader
                                        title="Push Campaigns History"
                                        subtitle="Broadcast system-wide alerts and manage targeted push notifications"
                                        action={
                                            <Link
                                                to="/notification-management/add"
                                                className="cms-add-btn d-inline-flex align-items-center text-decoration-none"
                                            >
                                                <i className="fas fa-plus me-2" />
                                                Launch New Campaign
                                            </Link>
                                        }
                                    />

                                    <Table
                                        key={"notification-management-table"}
                                        tableTitles={[
                                            "S.No.",
                                            "Target Segment",
                                            "Campaign Title",
                                            "Message Extract",
                                            "Date Sent",
                                            "Status",
                                            "Actions",
                                        ]}
                                        dateFilter
                                        showEntries
                                        isLoading={isLoading}
                                        isFetching={isFetching}
                                        data={data?.data?.data?.docs}
                                        totalPages={Math.ceil(data?.data?.data?.totalPages || 0)}
                                        totalDocs={data?.data?.data?.totalDocs}
                                        page={page}

                                        setPage={setPage}
                                        perPage={perPage}
                                        setPerPage={setPerPage}
                                        from={from}
                                        setFrom={setFrom}
                                        to={to}
                                        setTo={setTo}
                                    >
                                        {data?.data?.data?.docs?.map((item, index) => (
                                                <tr key={item._id}>
                                                    <td>{getSerialNumber(data?.data?.data, index)}</td>
                                                    <td>
                                                        <span className={`cms-role-badge ${item.target === "user" ? "cms-role-badge--user" : item.target === "mover" ? "cms-role-badge--driver" : ""}`} style={item.target === "all" ? { background: "rgba(14, 165, 233, 0.12)", color: "#0284c7", border: "1px solid rgba(14, 165, 233, 0.2)" } : undefined}>
                                                            {item.target === "all" ? "Everyone" : item.target === "user" ? "Users" : "Drivers"}
                                                        </span>
                                                    </td>
                                                    <td className="fw-bold">{item.title}</td>
                                                    <td style={{ maxWidth: "280px" }}>
                                                        <p className="nt-message-preview m-0">{item.body}</p>
                                                    </td>
                                                    <td>
                                                        {item?.createdAt &&
                                                            format_date(item?.createdAt, "MM/DD/YYYY, hh:mm A")}
                                                    </td>
                                                    <td>
                                                        <span className="text-success small fw-bold">
                                                            <i className="fas fa-check-circle me-1"></i> Delivered
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                            <button
                                                                type="button"
                                                                className="nt-edit-btn"
                                                                onClick={() => handleResend(item._id, item.title)}
                                                                disabled={resendLoading}
                                                            >
                                                                <i className="fas fa-redo" />
                                                                Resend
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="cms-btn-cancel"
                                                                style={{ padding: "0.38rem 0.9rem", fontSize: "0.78rem", borderRadius: "999px" }}
                                                                onClick={() => handleDelete(item._id, item.title)}
                                                                disabled={deleteLoading}
                                                            >
                                                                <i className="fas fa-trash-alt me-1" />
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                    </Table>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
